export default __webpack_public_path__ + "static/media/email.inline.b3bb2003.svg";